/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { PillList, PersonalizationToggle } from '../../components/pillList'

interface PillListProps {
  pills: any;
  onChange?: (e: object) => void;
  isPersonalizationToggle?: boolean;
  showPersonalizationPills?: boolean;
  onCaretClick?: (input: boolean) => void;
  displayHeaderCartoonBoolean?: boolean;
  personalizationCompleted: boolean;
}

const PillListContainer = ({ 
  pills, 
  onChange, 
  isPersonalizationToggle, 
  showPersonalizationPills,
  onCaretClick,
  displayHeaderCartoonBoolean,
  personalizationCompleted,
}: PillListProps) => {

  const pillListSorted = [...pills.list].sort((a, b) => a.value.localeCompare(b.value));
  const [activePills, setActivePills] = useState<{ [key: string]: boolean }>({});

  // sets initial activePills object to all false values
  useEffect(() => {
    const initialActivePills: { [key: string]: boolean } = {};
    for (let i = 0; i < pillListSorted.length; i++) {
      initialActivePills[pillListSorted[i].value] = false;
    }
    setActivePills(initialActivePills);
  }, [pills.list]);

  const handleToggleClick = (value: string) => {
    const newActivePills = {...activePills};
    newActivePills[value] = !newActivePills[value]
    setActivePills(newActivePills)

    let selectedPills = ''
    for(let i = 0; i < pillListSorted.length; i++) {
      if (newActivePills[pillListSorted[i].value]) {
        selectedPills += pillListSorted[i].value + ',';
      }
    }

    let response = { 
      target: { 
        value: selectedPills, 
        fieldId: pills.fieldId,
        type: pills.inputType
      }
    }
    onChange ? onChange(response) : null;
  }

  return (
    <>
      {isPersonalizationToggle ? (
        <PersonalizationToggle 
          pills={pillListSorted}
          activePills={activePills}
          label={pills.label}
          onClick={handleToggleClick}
          showPersonalizationPills={showPersonalizationPills}
          onCaretClick={onCaretClick}
          displayHeaderCartoonBoolean={displayHeaderCartoonBoolean}
          personalizationCompleted={personalizationCompleted}
        />
      ) : (
        <PillList 
          pills={pillListSorted} 
          label={pills.label}
          activePills={activePills}
          onClick={handleToggleClick}
      />
      )}
    </>
  )
}

PillListContainer.defaultProps = {
  onChange: undefined
}

export default PillListContainer;try {
    // @ts-ignore
    pillList.displayName = "pillList";
    // @ts-ignore
    pillList.__docgenInfo = { "description": "", "displayName": "pillList", "props": { "pills": { "defaultValue": null, "description": "", "name": "pills", "required": true, "type": { "name": "any" } }, "onChange": { "defaultValue": { value: "undefined" }, "description": "", "name": "onChange", "required": false, "type": { "name": "(e: object) => void" } }, "isPersonalizationToggle": { "defaultValue": null, "description": "", "name": "isPersonalizationToggle", "required": false, "type": { "name": "boolean" } }, "showPersonalizationPills": { "defaultValue": null, "description": "", "name": "showPersonalizationPills", "required": false, "type": { "name": "boolean" } }, "onCaretClick": { "defaultValue": null, "description": "", "name": "onCaretClick", "required": false, "type": { "name": "(input: boolean) => void" } }, "displayHeaderCartoonBoolean": { "defaultValue": null, "description": "", "name": "displayHeaderCartoonBoolean", "required": false, "type": { "name": "boolean" } }, "personalizationCompleted": { "defaultValue": null, "description": "", "name": "personalizationCompleted", "required": true, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/pillList/pillList.tsx#pillList"] = { docgenInfo: pillList.__docgenInfo, name: "pillList", path: "src/containers/pillList/pillList.tsx#pillList" };
}
catch (__react_docgen_typescript_loader_error) { }